"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Shimmer = _interopRequireDefault(require("../Shimmer"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _Container = _interopRequireDefault(require("../Container"));

var _constant = require("../constant");

var _shimmerJourney = _interopRequireDefault(require("./shimmerJourney.proptypes"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var setPadding = function setPadding(_ref) {
  var viewport = _ref.viewport,
      theme = _ref.theme;
  return viewport !== _constant.DEVICE_TYPE.DESKTOP ? "".concat(theme.space.none) : "".concat(theme.space.semiLarge, " ").concat(theme.space.standard);
};

var ShimmerJourneyWrapper = _styledComponents.default.div.withConfig({
  displayName: "ShimmerJourney__ShimmerJourneyWrapper",
  componentId: "sc-1g822u7-0"
})(["padding:", ";.shimmer-journey{padding:", " ", ";}"], function (props) {
  return setPadding(props);
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.space.micro;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.space.none;
});

var ShimmerJourneyDesktopView = _styledComponents.default.div.withConfig({
  displayName: "ShimmerJourney__ShimmerJourneyDesktopView",
  componentId: "sc-1g822u7-1"
})(["&:not(:nth-last-child(-n+1)){margin-bottom:", ";border-bottom 1px solid ", ";padding-bottom:", ";width:fit-content;}"], function (props) {
  return props.theme.space.semiLarge;
}, function (props) {
  return props.theme.colors.greyLight;
}, function (props) {
  return props.theme.space.semiLarge;
});

var ShimmerJourneyMobileView = _styledComponents.default.div.withConfig({
  displayName: "ShimmerJourney__ShimmerJourneyMobileView",
  componentId: "sc-1g822u7-2"
})(["padding:", " ", ";&:not(:nth-last-child(-n+2)){padding:", " ", " ", ";.shimmer-journey-mobile-card{border-bottom 1px solid ", ";padding-bottom:", ";}}&:last-child{background-color:", ";.shimmer-journey:last-child{margin-top:", ";}}"], function (props) {
  return props.theme.space.standard;
}, function (props) {
  return props.theme.space.small;
}, function (props) {
  return props.theme.space.standard;
}, function (props) {
  return props.theme.space.small;
}, function (props) {
  return props.theme.space.none;
}, function (props) {
  return props.theme.colors.greyLight;
}, function (props) {
  return props.theme.space.standard;
}, function (props) {
  return props.theme.colors.greyLighter;
}, function (props) {
  return props.theme.space.none;
});

var ShimmerJourneyDesktopCard = _styledComponents.default.div.withConfig({
  displayName: "ShimmerJourney__ShimmerJourneyDesktopCard",
  componentId: "sc-1g822u7-3"
})(["width:20vw;display:inline-grid;&:nth-child(2){padding-right:", ";}"], function (props) {
  return props.theme.space.semiXXLarge;
});

var ShimmerJourneyMobileCard = _styledComponents.default.div.withConfig({
  displayName: "ShimmerJourney__ShimmerJourneyMobileCard",
  componentId: "sc-1g822u7-4"
})([".shimmer-journey:last-child{margin-top:", ";}"], function (props) {
  return props.theme.space.normal;
});

var ShimmerJourney = function ShimmerJourney(props) {
  var journey = props.journey,
      borderRadius = props.borderRadius,
      height = props.height,
      viewport = props.viewport,
      theme = props.theme,
      accessible = props.accessible,
      customProperties = props.customProperties;
  var shimmerJourney = [];
  var shimmerCustomProps = {
    className: 'shimmer-journey'
  };
  var shimmerOtherProps = {
    accessible: false,
    borderRadius: borderRadius,
    height: height,
    customProperties: shimmerCustomProps
  };
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var tabIndex = !accessible ? '-1' : '0';

  if (viewport === _constant.DEVICE_TYPE.DESKTOP) {
    for (var i = 0; i < journey; i += 1) {
      shimmerJourney.push( /*#__PURE__*/_react.default.createElement(ShimmerJourneyDesktopView, null, /*#__PURE__*/_react.default.createElement(ShimmerJourneyDesktopCard, null, /*#__PURE__*/_react.default.createElement(_Shimmer.default, (0, _extends2.default)({
        width: "55%"
      }, shimmerOtherProps))), /*#__PURE__*/_react.default.createElement(ShimmerJourneyDesktopCard, null, /*#__PURE__*/_react.default.createElement(_Shimmer.default, (0, _extends2.default)({
        width: "100%"
      }, shimmerOtherProps)), /*#__PURE__*/_react.default.createElement(_Shimmer.default, (0, _extends2.default)({
        width: "45%"
      }, shimmerOtherProps))), /*#__PURE__*/_react.default.createElement(ShimmerJourneyDesktopCard, null, /*#__PURE__*/_react.default.createElement(_Shimmer.default, (0, _extends2.default)({
        width: "100%"
      }, shimmerOtherProps)), /*#__PURE__*/_react.default.createElement(_Shimmer.default, (0, _extends2.default)({
        width: "45%"
      }, shimmerOtherProps)))));
    }
  } else {
    for (var _i = 0; _i < journey; _i += 1) {
      if (_i === journey - 1) {
        shimmerJourney.push( /*#__PURE__*/_react.default.createElement(ShimmerJourneyMobileView, null, /*#__PURE__*/_react.default.createElement(ShimmerJourneyMobileCard, {
          className: "shimmer-journey-mobile-card"
        }, /*#__PURE__*/_react.default.createElement(_Shimmer.default, (0, _extends2.default)({
          width: "80%"
        }, shimmerOtherProps)), /*#__PURE__*/_react.default.createElement(_Shimmer.default, (0, _extends2.default)({
          width: "60%"
        }, shimmerOtherProps)), /*#__PURE__*/_react.default.createElement(_Shimmer.default, (0, _extends2.default)({
          width: "40%"
        }, shimmerOtherProps)))));
        shimmerJourney.push( /*#__PURE__*/_react.default.createElement(ShimmerJourneyMobileView, null, /*#__PURE__*/_react.default.createElement(ShimmerJourneyMobileCard, {
          className: "shimmer-journey-mobile-card"
        }, /*#__PURE__*/_react.default.createElement(_Shimmer.default, (0, _extends2.default)({
          width: "50%"
        }, shimmerOtherProps)), /*#__PURE__*/_react.default.createElement(_Shimmer.default, (0, _extends2.default)({
          width: "25%"
        }, shimmerOtherProps)))));
      } else {
        shimmerJourney.push( /*#__PURE__*/_react.default.createElement(ShimmerJourneyMobileView, null, /*#__PURE__*/_react.default.createElement(ShimmerJourneyMobileCard, {
          className: "shimmer-journey-mobile-card"
        }, /*#__PURE__*/_react.default.createElement(_Shimmer.default, (0, _extends2.default)({
          width: "80%"
        }, shimmerOtherProps)), /*#__PURE__*/_react.default.createElement(_Shimmer.default, (0, _extends2.default)({
          width: "60%"
        }, shimmerOtherProps)), /*#__PURE__*/_react.default.createElement(_Shimmer.default, (0, _extends2.default)({
          width: "40%"
        }, shimmerOtherProps)))));
      }
    }
  }

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(_Theme.default, {
      theme: theme
    }, /*#__PURE__*/_react.default.createElement(_Container.default, null, /*#__PURE__*/_react.default.createElement(ShimmerJourneyWrapper, (0, _extends2.default)({
      tabIndex: tabIndex,
      viewport: viewport
    }, customProperties), shimmerJourney)));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

ShimmerJourney.propTypes = _shimmerJourney.default.PropTypes;
ShimmerJourney.defaultProps = _shimmerJourney.default.DefaultProps;
var _default = ShimmerJourney;
exports.default = _default;